export default __webpack_public_path__ + "static/N0036-d187d46e32bc22da23af6c4137cf8bc8.png";